import { PartnerData } from '@/components/b2b/shared/types';
import { PartnerData as DTCPartnerData } from '@/components/dtcPartnerships/shared/types';

export const SET_PARTNER = 'SET_PARTNER';

export interface SetPartnerAction {
	type: typeof SET_PARTNER;
	payload: PartnerData | DTCPartnerData;
}
